import { render, staticRenderFns } from "./mailpadWindow.vue?vue&type=template&id=08ebd286&"
import script from "./mailpadWindow.vue?vue&type=script&lang=js&"
export * from "./mailpadWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports